import LineGradient from "../components/LineGradient";
import useMediaQuery from "../hooks/useMediaQuery";
import { motion } from "framer-motion";


const Myskills = () => {
    const isAboveMediumScreens = useMediaQuery('(min-width: 1060px)');

    return(
        <section id="skills" className="pt-10 pb-24">
            {/* header and image section */}

            <div
            className="md:flex md:justify-between md:gap-16 mt-32"
            >
                <motion.div
                className="md:w-1/3"
                initial="hidden"
                whileInView="visible"
                viewport={{once: true, amount: 0.5}}
                transition={{duration: 0.5}}
                variants={{
                    hidden: {opacity: 0, x: -50},
                    visible: {opacity: 1, x: 0}
                }}
                >
                    <p
                    className="font-acorn font-semibold text-4xl mb-5"
                    >
                    MY <span className="text-red">SKILLS</span>
                    </p>
                    <LineGradient width="1/3" />
                    
                    <p
                    className="mt-10 mb-7"
                    >
                        Proficient in a broad range of development tools and programming languages, with expertise spanning front-end design, 
                        back-end integration, machine learning, and embedded systems. 
                        Adept at solving complex problems through efficient, scalable solutions in diverse environments.
                    </p>
                </motion.div>

                <div className="mt-16 md:mt-0">
                {
                    isAboveMediumScreens ? (
                        <div
                            className="relative z-0 ml-20 before:absolute before:-top-10 before:-left-10
                            before:w-full before:h-full before:bg-gradient-to-r from-blue to-red before:z-[-1]"
                             >
              
                             <div
                             className="relative z-0 before:absolute before:-top-9 before:-left-9
                             before:w-full before:h-full before:bg-deep-blue before:z-[-1]"
                             >
                             <img
                                alt="skills"
                                className="z-10"
                                src="assets/skills-image.png"
                                 />
              
                             </div>
                         </div>
                        
                    ) : (
                        <img
                        alt="skills"
                        className="z-10"
                        src="assets/skills-image.png"
                        />
                    
                    )
                }

                </div>

            </div>

            {/* skills  */}
            <div className="md:flex md:justify-between mt-16 gap-32">
                {/* Experience*/}
                <motion.div
                className="md:w-1/3 mt-10"
                initial="hidden"
                whileInView="visible"
                viewport={{once: true, amount: 0.5}}
                transition={{duration: 0.5}}
                variants={{
                    hidden: {opacity: 0, y: 50},
                    visible: {opacity: 1, y: 0}
                }}
                >

                    <div className="relative h-32">

                    <div className="z-10">
                    <p className="font-playfair font-semibold text-5xl">01</p>
                    <p className="font-playfair font-semibold text-3xl mt-3">Experience</p>
                    </div>
                    <div className="w-1/2 md:w-3/4 h-32 bg-blue absolute right-0 top-0 z-[-1]" />
                    </div>
                    <p className="mt-5">
                    A proven track record of delivering innovative solutions, from research-led projects on edge computing to hands-on teaching experiences in web technologies. 
                    Demonstrated ability to manage projects through meticulous planning, technical expertise, and an adaptable approach, resulting in high-impact deliverables.
                    </p>
                </motion.div>
                


                {/* Visionary*/}
                <motion.div
                className="md:w-1/3 mt-10"
                initial="hidden"
                whileInView="visible"
                viewport={{once: true, amount: 0.5}}
                transition={{ delay:0.2,duration: 0.5}}
                variants={{
                    hidden: {opacity: 0, y: 50},
                    visible: {opacity: 1, y: 0}
                }}
                >

                    <div className="relative h-32">

                    <div className="z-10">
                    <p className="font-playfair font-semibold text-5xl">02</p>
                    <p className="font-playfair font-semibold text-3xl mt-3">Visionary</p>
                    </div>
                    <div className="w-1/2 md:w-3/4 h-32 bg-red absolute right-0 top-0 z-[-1]" />
                    </div>
                    <p className="mt-5">
                    Possesses a forward-thinking approach to technology, consistently exploring new methodologies and emerging tech trends to anticipate industry needs. 
                    Driven by a strong vision for future advancements, with a track record of integrating unique ideas that transform standard applications into forward-focused solutions.
                    </p>
                </motion.div>


                {/* Problem Solver*/}
                <motion.div
                className="md:w-1/3 mt-10"
                initial="hidden"
                whileInView="visible"
                viewport={{once: true, amount: 0.5}}
                transition={{ delay:0.4,duration: 0.5}}
                variants={{
                    hidden: {opacity: 0, y: 50},
                    visible: {opacity: 1, y: 0}
                }}
                >

                    <div className="relative h-32">

                    <div className="z-10">
                    <p className="font-playfair font-semibold text-5xl">03</p>
                    <p className="font-playfair font-semibold text-3xl mt-3">Problem Solver</p>
                    </div>
                    <div className="w-1/2 md:w-3/4 h-32 bg-yellow absolute right-0 top-0 z-[-1]" />
                    </div>
                    <p className="mt-5">
                    Approaches challenges with a solution-oriented mindset, dissecting complex problems to uncover streamlined, effective solutions.
                     Experienced in breaking down technical issues in high-stakes environments, 
                     bringing analytical rigor and creative strategies to deliver results under diverse conditions.
                    </p>
                </motion.div>

            </div>

        </section>
    );

};

export default Myskills;